export enum FirmRelationType {
	NotSet = 0,
	Promoter = 1,
	Sponsor = 2,
}


// WEBPACK FOOTER //
// ./src/app/models/firm-relation-type.enum.ts